import { useState } from 'react';
import styles from './AccountingInvoice.module.css';
import DynamicTable from '../../components/DynamicTable/DynamicTable';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import HeadingAndDropDown from '../../components/HeadingAndDropDown/HeadingAndDropDown';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import { IoReceiptOutline } from 'react-icons/io5';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';
import { FaUserPlus } from 'react-icons/fa';
import SearchBar from '../../components/SearchBar/SearchBar';
import Dropdown from '../../components/Dropdown/Dropdown';
import CheckboxAndData from '../../components/CheckboxAndData/CheckboxAndData';
import CalendarInput from '../../components/CalendarInput/CalendarInput';
import HeadingAndData from '../../components/HeadingAndData/HeadingAndData';
import RadioComponent from '../../components/RadioComponent/RadioComponent';
import { MdOutlineDelete } from 'react-icons/md';
const AccountingInvoice = () => {
  const dispatch = useDispatch();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [search, setSearch] = useState('');
  const dummyStudents = [
    { id: 's1', name: 'John' },
    { id: 's2', name: 'Steeve' },
    { id: 's3', name: 'John' },
    { id: 's4', name: 'Steeve' },
    { id: 's5', name: 'John' },
    { id: 's6', name: 'Steeve' },
    { id: 's7', name: 'John' },
    { id: 's8', name: 'Steeve' },
    { id: 's9', name: 'John' },
    { id: 's10', name: 'Steeve' },
  ];

  const tableHeadings = [
    { title: 'Item Name', accessor: 'name' },
    { title: 'Gross Amount', accessor: 'grossAmount' },
    { title: 'Discount', accessor: 'discount' },
    { title: 'Tax', accessor: 'tax' },
    { title: 'Sub Total', accessor: 'subTotal' },
  ];

  const invoiceTable1headings = [
    { title: 'Item Name', accessor: 'name' },
    { title: 'Quantity', accessor: 'quantity' },
    { title: 'Unit Price', accessor: 'unitPrice' },
    { title: 'Tax', accessor: 'tax' },
    { title: 'Amount', accessor: 'amount' },
    { title: '', accessor: 'action' },
  ];

  const [invoiceTable1, setInvoiceTable1] = useState([
    { id: 1, name: 'ITEM 1', quantity: 1, unitPrice: 120, tax: 10 },
    { id: 2, name: 'ITEM 1', quantity: 1, unitPrice: 120, tax: 10 },
    { id: 3, name: 'ITEM 1', quantity: 1, unitPrice: 120, tax: 10 },
  ]);

  const invoiceTable1Data = invoiceTable1.map((row) => ({
    name: (
      <Dropdown
        className={styles.DropdownField}
        value={row.name}
        options={['ITEM 1', 'ITEM 2', 'ITEM 3']}
        onChange={(e) => {
          setInvoiceTable1((prev) =>
            prev.map((r) =>
              r.id === row.id ? { ...r, name: e.target.value } : r
            )
          );
        }}
      />
    ),
    quantity: (
      <div className={styles.inputFieldBox}>
        <input
          type="number"
          value={row.quantity}
          onChange={(e) => {
            const value = parseInt(e.target.value || 0);
            setInvoiceTable1((prev) =>
              prev.map((r) => (r.id === row.id ? { ...r, quantity: value } : r))
            );
          }}
        />
      </div>
    ),
    unitPrice: (
      <div className={styles.inputFieldBox}>
        <input
          type="number"
          value={row.unitPrice}
          onChange={(e) => {
            const value = parseFloat(e.target.value || 0);
            setInvoiceTable1((prev) =>
              prev.map((r) =>
                r.id === row.id ? { ...r, unitPrice: value } : r
              )
            );
          }}
        />
      </div>
    ),
    tax: (
      <div className={styles.inputFieldBox}>
        <input
          type="number"
          value={row.tax}
          onChange={(e) => {
            const value = parseFloat(e.target.value || 0);
            setInvoiceTable1((prev) =>
              prev.map((r) => (r.id === row.id ? { ...r, tax: value } : r))
            );
          }}
        />
      </div>
    ),
    amount: `INR ${
      row.quantity * row.unitPrice + row.tax
        ? row.quantity * row.unitPrice + row.tax
        : 0
    }`,
    action: (
      <MdOutlineDelete
        size={24}
        color="var(--Error_Color)"
        style={{ cursor: 'pointer' }}
        onClick={() => handleDeleteRow(row.id)}
      />
    ),
  }));

  const [invoiceTable2, setInvoiceTable2] = useState([
    {
      name: 'ITEM 1',
      grossAmount: 'INR 120',
      discount: '-',
      tax: 'INR 10',
      subTotal: 'INR 130',
    },
  ]);

  const handleDeleteRow = (idToDelete) => {
    setInvoiceTable1((prev) => prev.filter((row) => row.id !== idToDelete));
  };
  const handleAddNewLine = () => {
    const newId = Date.now();
    setInvoiceTable1((prev) => [
      ...prev,
      {
        id: newId,
        name: 'ITEM 1',
        grossAmount: 0,
        discount: 0,
        amount: 0,
      },
    ]);
  };

  const [invoiceDate, setInvoiceDate] = useState('');
  const [billingFromDate, setBillingFromDate] = useState('');
  const [billingToDate, setBillingToDate] = useState('');
  const [selectedFeePlan, setSelectedFeePlan] = useState('');

  const feePlanOptions = [
    { label: 'Basic Plan', value: 'basic' },
    { label: 'Standard Plan', value: 'standard' },
    { label: 'Premium Plan', value: 'premium' },
  ];

  const handleFeePlanChange = (e) => {
    setSelectedFeePlan(e.target.value);
  };

  const handleCheckboxChange = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const handleSave = () => {
    console.log('Selected students:', selectedStudents);
    dispatch(closeModal()); // Optional: close modal after save
  };

  const handleClose = () => {
    dispatch(closeModal());
  };
  const filteredStudents = dummyStudents.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase())
  );

  const [sendInvoiceToParent, setSendInvoiceToParent] = useState('yes');

  const [isDueImmediately, setIsDueImmediately] = useState(false);
  return (
    <div className={styles.totaldata}>
      <div className={styles.container}>
        <div className={styles.modal}>
          <div className={styles.header}>
            <HeadingAndIcon
              icon={<IoReceiptOutline />}
              heading="Create Invoice"
              headingClass={styles.primaryHeading}
              color={'var(--Primary_Color)'}
            />

            <ToClose onClose={handleClose} />
          </div>

          {/* <div className={styles.invoiceInfo}>
            <p>
              <span className={styles.primary}>First Term</span>, Monthly
              Billing
            </p>
            <p>
              <span className={styles.secondline}>Next Invoice Details</span>,
              Your invoice will be generated on 07/12/2025 due on 13/12/2025 for
              the period of 01/11/2025 to 30/11/2025
            </p>
          </div> */}

          {/* 🧾 Top Table */}

          <div className={styles.seconddivision}>
            <div className={styles.heading}>
              <HeadingAndIcon
                icon={<IoReceiptOutline />}
                heading="Invoice Details"
                headingClass={styles.primaryHeading}
                color={'var(--Primary_Color)'}
              />
            </div>

            <div className={styles.whiteshadowbox}>
              <div className={styles.sectionRow}>
                <CalendarInput
                  fieldLabel="Invoice Date"
                  label="Choose date"
                  required={true}
                  value={invoiceDate}
                  onChange={setInvoiceDate}
                />
                <CalendarInput
                  fieldLabel="Billing Period"
                  label="Choose from date"
                  required={true}
                  value={billingFromDate}
                  onChange={setBillingFromDate}
                />
                <CalendarInput
                  fieldLabel="Billing Period"
                  label="Choose to date"
                  required={true}
                  value={billingToDate}
                  onChange={setBillingToDate}
                />
              </div>
              <div className={styles.sectionRow}>
                <div className={styles.inputAndCheckBoxContainer}>
                  <p>After how many days invoice will be due</p>
                  <div className={styles.fieldsContainer}>
                    <HeadingAndData placeholder="Enter Days" />
                    <CheckboxAndData
                      label={'Set Due immediately'}
                      labelColor={'var(--Grey_Color)'}
                      labelSize={14}
                      checkboxSize={14}
                      checked={isDueImmediately}
                      onChange={() => setIsDueImmediately(!isDueImmediately)}
                    />
                  </div>
                </div>
                <HeadingAndDropDown
                  label="Select Fee Plan"
                  required={true}
                  name="feePlan"
                  value={selectedFeePlan}
                  onChange={handleFeePlanChange}
                  options={feePlanOptions}
                  placeholder="Fee plan"
                />

                <div className={styles.radioGroup}>
                  <span className={styles.radioLabel}>
                    Send debit to Parent *
                  </span>
                  <div className={styles.radioOptions}>
                    <RadioComponent
                      name="sendInvoiceToParent"
                      value="yes"
                      label="Yes"
                      checked={sendInvoiceToParent === 'yes'}
                      onChange={(e) => setSendInvoiceToParent(e.target.value)}
                    />
                    <RadioComponent
                      name="sendInvoiceToParent"
                      value="no"
                      label="No"
                      checked={sendInvoiceToParent === 'No'}
                      onChange={(e) => setSendInvoiceToParent(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.tableSection}>
                {/* 📝 Form Below Table */}
                <DynamicTable
                  headings={invoiceTable1headings}
                  columnData={invoiceTable1Data}
                />
                <div className={styles.tablebelow}>
                  <div className={styles.row}>
                    <HeadingAndDropDown
                      label="Discount Code"
                      name="discount"
                      options={[{ label: 'Code A', value: 'A' }]}
                    />
                    <HeadingAndDropDown
                      label="Tax"
                      name="tax"
                      options={[{ label: 'GST 18%', value: 'gst18' }]}
                    />
                    <CheckboxAndData
                      // checked={
                      //   selectedStudents.length === filteredStudents.length
                      // }
                      // onChange={(e) =>
                      //   setSelectedStudents(
                      //     e.target.checked
                      //       ? filteredStudents.map((s) => s.id)
                      //       : []
                      //   )
                      // }
                      label={'Refundable'}
                      checkboxSize={14}
                      labelSize={16}
                    />
                  </div>

                  <div className={styles.noteSection}>
                    <label className={styles.noteLabel}>School Notes</label>
                    <textarea
                      className={styles.textarea}
                      placeholder="Enter any description you want"
                    />
                  </div>

                  <div className={styles.noteSection}>
                    <label className={styles.noteLabel}>Parent Notes</label>
                    <textarea
                      className={styles.textarea}
                      placeholder="Enter any description you want"
                    />
                  </div>
                  <div className={styles.bothactions}>
                    <div className={styles.addMore} onClick={handleAddNewLine}>
                      Add New Line
                    </div>
                    <div className={styles.actions}>
                      <SaveAndCancel onCancel={() => {}} onSave={() => {}} />
                    </div>
                  </div>
                </div>
              </div>

              {/* 🧾 Bottom Summary Table */}
              <div className={styles.summarySection}>
                <DynamicTable
                  headings={tableHeadings}
                  columnData={invoiceTable2}
                />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.settleWithCreditOption}>
          <CheckboxAndData
            // checked={
            //   selectedStudents.length === filteredStudents.length
            // }
            // onChange={(e) =>
            //   setSelectedStudents(
            //     e.target.checked
            //       ? filteredStudents.map((s) => s.id)
            //       : []
            //   )
            // }
            label={'Settle With Credit'}
            checkboxSize={14}
            labelSize={16}
            labelColor={'var(--Primary_Color)'}
          />
        </div>
        <div className={styles.sectionCard}>
          <div className={styles.sectionHeader}>
            <HeadingAndIcon icon={<FaUserPlus />} heading="Assign Students" />
          </div>
          <div className={styles.studentdata}>
            <div className={styles.controls}>
              <SearchBar
                placeholder="Search Student"
                onChange={(e) => setSearch(e.target.value)}
              />
              <Dropdown
                bgColor="var(--Utility_Color9)"
                label="Room"
                options={['Room A', 'Room B']}
              />
            </div>

            <div className={styles.listHeader}>
              <CheckboxAndData
                checked={selectedStudents.length === filteredStudents.length}
                onChange={(e) =>
                  setSelectedStudents(
                    e.target.checked ? filteredStudents.map((s) => s.id) : []
                  )
                }
                label={'Select All'}
                checkboxSize={14}
                labelSize={16}
              />
            </div>

            <div className={styles.grid}>
              {filteredStudents.map((student) => (
                <CheckboxAndData
                  key={student.id}
                  checked={selectedStudents.includes(student.id)}
                  onChange={() => handleCheckboxChange(student.id)}
                  label={student.name}
                  checkboxSize={14}
                  labelSize={16}
                  labelColor={'var(--Primary_Color)'}
                />
              ))}
            </div>

            <div className={styles.footerActions}>
              <SaveAndCancel onSave={handleSave} onCancel={handleClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountingInvoice;
